import PubSub from 'pubsub-js';
import isUndefined from 'lodash.isundefined'

let groupsData = [];
let sortedGroups = {};

if(!isUndefined(window.groupsData)) {

  groupsData = window.groupsData;

  const groupsEl = $('.dashboard__sensor-groups');
  const groupsCreateSelectParent = $('.sensor-groups-create__parent');

  const loadData = () => {

    window.groupsData = groupsData;

    $.each(groupsData, (i, group) => {

      if(group.is_default == 1) {

        PubSub.publish('groups.updated', groupsData);
        PubSub.publish('groups.select', group.id);
      }

    });

  };

  groupsEl.on('click', '.dashboard__sensor-group__name', e => {
    PubSub.publish('groups.select', $(e.currentTarget).parents('.dashboard__sensor-group').data('group'));
  });

  groupsEl.on('click', '.dashboard__sensor-group__expand', e => {
    const parentGroup = $(e.currentTarget).parents('.dashboard__sensor-group');
    parentGroup.toggleClass('is-expanded');

    // select the parent group if we are collapsing and have a selected child
    if(!parentGroup.hasClass('is-expanded') && parentGroup.find('.is-active').length > 0) {
      PubSub.publish('groups.select', parentGroup.data('group'));
    }

  });

  PubSub.subscribe('groups.select', (msg, groupId) => {
    groupsEl.find(`.dashboard__sensor-group`).toggleClass('is-active', false);
    groupsEl.find(`.dashboard__sensor-group[data-group="${groupId}"]`).toggleClass('is-active', true);
  });

  const sortGroups = () => {

    sortedGroups = {};

    $.each(groupsData, (i, group) => {

      // strange bug with parsing group data
      if(i == 'undefined') return;

      if(group.parent_id == 0) {
        if (isUndefined(sortedGroups[group.id])) {
          sortedGroups[group.id] = {};
          sortedGroups[group.id].id = group.id;
          sortedGroups[group.id].group_name = group.group_name;

          if(isUndefined(sortedGroups[group.id]['child_groups'])) {
            sortedGroups[group.id]['child_groups'] = [];
          }

        }
      } else {

        if (isUndefined(sortedGroups[group.parent_id])) {
          sortedGroups[group.parent_id] = {};
          sortedGroups[group.parent_id]['child_groups'] = [];
        }

        sortedGroups[group.parent_id].child_groups.push({
          id: group.id,
          group_name: group.group_name,
        });

      }

    });

    window.sortedGroups = sortedGroups;

  };

  const render = () => {

    sortGroups();

    let output = '';

    Object.keys(sortedGroups).forEach(key => {
      const parentGroup = sortedGroups[key];

      output += `
        <div class="dashboard__sensor-group" data-group="${parentGroup['id']}">
          
          ${parentGroup.child_groups.length > 0 ? '<button class="dashboard__sensor-group__expand" type="button"></button>' : ''}         
          <div class="dashboard__sensor-group__name">${parentGroup['group_name']}</div>`;

      if(parentGroup.child_groups.length > 0) {

        output += `<div class="dashboard__sensor-group__children" data-for="${parentGroup['id']}">`;

        parentGroup.child_groups.forEach(childGroup => {
          output += `
          <div class="dashboard__sensor-group" data-group="${childGroup['id']}">
            <div class="dashboard__sensor-group__name">${childGroup['group_name']}</div>
          </div>`;
        });

        output += '</div>';

      }
          
       output += '</div>';

    });

    groupsEl.html(output);

  };

  $('.sensor-groups-create__form').on('submit', e => {

    e.preventDefault();
    console.log();

    $.post({
      url: window.site.home + '/process/ajax/create-group.php',
      data: $(e.target).serialize(),
      dataType: 'json',
      success: r => {

        if(r.is_error) {
          console.log(r.message);
        } else {
          groupsData[r.data.id] = r.data;
          PubSub.publish('groups.updated', groupsData);
        }

      }
    })


  });

  /**
   * The group got updated dynamically
   */
  PubSub.subscribe('groups.updated', (msg, data) => {
    groupsData[data.id] = data;
  });

  PubSub.subscribe('groups.updated', () => {
    let output = '<option value="" selected>None</option>';

    $.each(groupsData, (i, group) => {
      if(group.parent_id == 0) {
        output += `<option value="${group.id}">${group['group_name']}</option>`;
      }
    });

    groupsCreateSelectParent.html(output);

    window.groupsData = groupsData;

  });

  PubSub.subscribe('groups.updated', render);

  loadData();

}
